import Bugsnag from '@bugsnag/js'
require('./utils');

let bundleBugsnagKey = process.env.MIX_BUGSNAG_KEY;

let dummyBugsnag = {
    notify: (error) => console.warn(error),
    leaveBreadcrumb: () => {},
    setUser: () => {},
    setContext: () => {},
    setMetadata: () => {},
    clearMetadata: () => {},
    addOnError: () => {},
    removeOnError: () => {},
    addOnSession: () => {},
    removeOnSession: () => {},
    getPlugin: () => ({}),
    isStarted: () => false
};
window.bugsnagClient = dummyBugsnag;

try {
    if ((bundleBugsnagKey?.trim() ?? '').length === 0) {
        throw new Error('[Bugsnag] API key is not set.');
    }

    if (typeof Bugsnag === 'undefined') {
        throw new Error('[Bugsnag] Object is undefined.');
    }

    window.bugsnagClient = Bugsnag.start({
        apiKey: bundleBugsnagKey
        // autoTrackSessions: false // prevent CORS errors
    });
} catch (error) {
    window.bugsnagClient.notify(error);
}
